import React from "react";
import Breadcrumb from "components/layout/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import { useStyles } from "components/layout/CommonStyles";

export function ScholarshipsRecessesNavHeader() {
  const classes = useStyles();
  const [t] = useTranslation();
  return (
    <div className="headerNewDesign">
      <Breadcrumb
        routes={[
          {
            label: t("HR.humanResource"),
            to: "/HumanResources",
          },
          { label: t("HR.scholarshipRecessList") },
        ]}
      />
      <div className="container-headerNewDesign">
        <h1 className={classes.titleNewDesign}>
          {t("HR.scholarshipRecessList")}
        </h1>
      </div>
    </div>
  );
}
